import { lazy, useState } from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router'
import { compose } from 'recompose'
import { setCurrentFilter } from 'shared/redux/creation-filters'
import {
    resetCreationTool,
    setCreationLocation,
    setCreationUploadInfo,
    updateCreationTool,
} from 'shared/redux/creation-tool'
import { getUser } from 'shared/redux/reducers'
import { getMimeTypes } from 'shared/util/gif-maker-util'
import HTML5Backend from 'shared/util/react-dnd-html5-backend'
import { createGlobalStyle } from 'styled-components'
import { clearError } from '../../redux/error'
import BackButton from '../back-button/back-button'
import { GifMakerContext } from '../gif-maker-context'
import { DOWNLOAD, FINALIZE, UPLOAD, VIDEO_TRIM, ZOOM_MAKER } from '../route'
import Download from './download'
import { ZoomMakerFrame, ZoomMakerProps } from './types'
import Upload from './upload'
import Welcome from './welcome'

const Finalize = lazy(() => import(/* webpackChunkName: "zoomMakerFinalize" */ '../finalize/finalize'))
const VideoTrim = lazy(() => import(/* webpackChunkName: "zoomMakerVideoTrim" */ '../video-trim/video-trim'))

export const FILE_TYPES = ['.png', '.jpeg', '.jpg', '.gif', '.mov', '.mp4']
export const MIME_TYPES = getMimeTypes(FILE_TYPES)
export const DEFAULT_TAGS = ['giphybackdropmaker']
export const DEFAULT_WIDTH = 1080
export const ASPECT_RATIO = 16 / 9

const BlackBackground = createGlobalStyle`
    body {
        background: #000;
    }
`

const ZoomMaker = (props: ZoomMakerProps) => {
    const [canvasFrames, setCanvasFrames] = useState<ZoomMakerFrame[]>([])
    const [canvasStickers, setCanvasStickers] = useState([])
    return (
        <GifMakerContext.Provider
            value={{
                basePath: ZOOM_MAKER,
                isBackgroundMaker: true,
                onSaveStickerIds: setCanvasStickers,
                updateDefaultTags: () => {
                    props.updateCreationTool({
                        defaultsTags: DEFAULT_TAGS,
                    })
                },
            }}
        >
            <BlackBackground />
            <div style={{ paddingTop: 15 }}>
                {!canvasFrames.length && <BackButton />}
                <Switch>
                    <Route
                        exact
                        path={`${ZOOM_MAKER}${VIDEO_TRIM}`}
                        render={() => <VideoTrim {...{ basePath: ZOOM_MAKER }} />}
                    />
                    <Route
                        exact
                        path={`${ZOOM_MAKER}${DOWNLOAD}`}
                        render={() => <Download {...{ canvasFrames, canvasStickers }} />}
                    />
                    <Route
                        exact
                        path={`${ZOOM_MAKER}${UPLOAD}`}
                        render={() => <Upload {...{ canvasFrames, canvasStickers }} />}
                    />
                    <Route
                        path={`${ZOOM_MAKER}${FINALIZE}`}
                        render={() => (
                            <Finalize
                                {...{ featuredStickers: props.featuredStickers, onSaveFrames: setCanvasFrames }}
                            />
                        )}
                    />
                    <Route render={() => <Welcome {...props} />} />
                </Switch>
            </div>
        </GifMakerContext.Provider>
    )
}

export default compose(
    HTML5Backend,
    connect((state) => ({ user: getUser(state) }), {
        updateCreationTool,
        clearError,
        setCreationUploadInfo,
        resetCreationTool,
        setCurrentFilter,
        setCreationLocation,
    })
)(ZoomMaker)
